import { setContext } from '@apollo/client/link/context';
import { getInstallId } from '#shared/helpers/getInstallId';
import { useAuthSDK } from '~/features/auth-sdk/business/useAuthSDK';
import { BASIC_BEARER, BASIC_TOKEN } from '@/shared/constants/auth';

// authLink – just need it to work with tokens in headers
export const authLink = setContext(async (_, { headers }) => {
  let token = null;
  if (import.meta.client) {
    const { authSDKController } = useAuthSDK();
    let authToken = await authSDKController.getToken();
    if (authToken) {
      token = `Bearer ${authToken}`;
    }
  }

  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : `Basic ${BASIC_TOKEN}`,
      'X-IID': getInstallId(),
      'Accept-Language': 'ru-RU',
    },
  };
});
